import { getClaims, transformUser } from './chunk-TVGQRSFH.mjs';
import { __export, __async } from './chunk-YUBKM3FG.mjs';
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { jsx } from 'react/jsx-runtime';

// src/providers/auth/index.tsx
var auth_exports = {};
__export(auth_exports, {
  AuthProvider: () => AuthProvider,
  useAuthContext: () => useAuthContext
});
var AuthContext = createContext({
  isSignedIn: false,
  isLoading: true,
  user: null,
  isAdmin: false,
  signIn: () => {
  },
  signOut: () => {
  },
  getAccessToken: () => __async(void 0, null, function* () {
    return "";
  })
});
var AuthContextProvider = ({ children }) => {
  const {
    isAuthenticated,
    isLoading: auth0Loading,
    loginWithRedirect,
    logout,
    user: auth0User,
    getAccessTokenSilently
  } = useAuth0();
  const [isLoading, setIsLoading] = useState(true);
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [user, setUser] = useState(null);
  useEffect(() => {
    const checkAuth = () => __async(void 0, null, function* () {
      try {
        const token = yield getAccessTokenSilently();
        const claims = getClaims(token);
        if (claims) {
          setIsAdmin(claims["x-hasura-default-role"] === "admin");
          const userId = claims["x-hasura-user-id"];
          setIsSignedIn(true);
          setUser(transformUser(userId, auth0User));
          setIsLoading(false);
        }
      } catch (error) {
        console.error("Session validation failed:", error);
      } finally {
        setIsLoading(false);
      }
    });
    if (!auth0Loading) {
      if (isAuthenticated) {
        checkAuth();
      } else {
        setIsLoading(false);
      }
    }
  }, [isAuthenticated, auth0Loading, getAccessTokenSilently]);
  const handleSignOut = useCallback(() => {
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }, [logout]);
  const contextValue = {
    isSignedIn,
    isLoading,
    user,
    isAdmin,
    signIn: loginWithRedirect,
    signOut: handleSignOut,
    getAccessToken: getAccessTokenSilently
  };
  return /* @__PURE__ */ jsx(AuthContext.Provider, { value: contextValue, children });
};
var AuthProvider = ({ config, children }) => {
  return /* @__PURE__ */ jsx(
    Auth0Provider,
    {
      domain: config.domain,
      clientId: config.clientId,
      authorizationParams: {
        audience: config.audience,
        redirect_uri: config.redirectUri
      },
      cookieDomain: config.cookieDomain,
      cacheLocation: "localstorage",
      children: /* @__PURE__ */ jsx(AuthContextProvider, { children })
    }
  );
};
var useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};

export { AuthProvider, auth_exports, useAuthContext };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-HVKTN277.mjs.map